import { render } from "./ModalCreateDepartment.vue?vue&type=template&id=e4a6807e&scoped=true"
import script from "./ModalCreateDepartment.vue?vue&type=script&lang=js"
export * from "./ModalCreateDepartment.vue?vue&type=script&lang=js"

import "./ModalCreateDepartment.vue?vue&type=style&index=0&id=e4a6807e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4a6807e"]])

export default __exports__